<template>
    <div id="org_settings_clients">

        <div class="card mb-3 table-card">
            <div class="card-header">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <h3 class="mt-2">Clients ({{ filtered_clients.length }})</h3>
                    </div>
                    <div class="col-md-6 d-none d-md-block">
                        <div class="d-flex justify-content-end justify-self-end gap-2">
                            <div class="position-relative">
                                <input 
                                    type="text" 
                                    class="search-box form-control me-1 py-2" 
                                    placeholder="Search by Name..." 
                                    aria-label="Search by Name..." 
                                    v-model="search_key" 
                                    @input="filterClients()" 
                                    autocomplete="one-time-code"
                                >
                                <i class="fa fa-search search-placeholder-icon" v-if="search_key === ''"></i>
                            </div>
                            <a :href="addClientUrl()" class="btn btn-primary float-end">
                                <span>
                                    <i class="fas fa-fw fa-plus"></i>
                                    Add Client
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-width-responsive">
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                <th @click="sortByKey('name')" class="d-table-cell">
                                    <div class="d-flex flex-row">
                                        Name
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{'sort-key-active': sort_key === 'name' && sort_order === 'asc'}" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{'sort-key-active': sort_key === 'name' && sort_order === 'des'}" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('plan_level')" class="d-none d-sm-table-cell">
                                    <div class="d-flex flex-row">
                                        Plan Level
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{'sort-key-active': sort_key === 'plan_level' && sort_order === 'asc'}" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{'sort-key-active': sort_key === 'plan_level' && sort_order === 'des'}" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('domain')" class="d-none d-md-table-cell">
                                    <div class="d-flex flex-row">
                                        Domain
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{'sort-key-active': sort_key === 'domain' && sort_order === 'asc'}" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{'sort-key-active': sort_key === 'domain' && sort_order === 'des'}" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th class="d-none d-lg-table-cell column-sort-disabled">
                                    <div class="d-flex flex-row">Subscription Paid By</div>
                                </th>
                                <th @click="sortByKey('created_at')" class="d-none d-md-table-cell">
                                    <div class="d-flex flex-row">
                                        Created On
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{'sort-key-active': sort_key === 'created_at' && sort_order === 'asc'}" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{'sort-key-active': sort_key === 'created_at' && sort_order === 'des'}" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th class="d-table-cell column-sort-disabled pe-3" width="1">
                                    <div class="d-flex flex-row">Action</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(client, index) in list_shown" :key="client.id" v-if="clients.length > 0">
                                <td class="d-table-cell">
                                    <img class="avatar rounded-circle me-3" :src="client.image" />
                                    <a :href="editClientUrl(client.id)">{{ client.name }}</a>
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    {{ propercase(client.plan_level) }}
                                </td>
                                <td class="d-none d-md-table-cell">
                                    {{ client.domain }}
                                </td>
                                <td class="d-none d-lg-table-cell">
                                    <template v-if="getActiveSubscriptionPaidBy(client)">
                                        <img
                                            class="avatar rounded-circle me-2 align-middle"
                                            :src="paidByPhotoUrl(client) || paidByIcon(client)"
                                            alt=""
                                            width="24"
                                            height="24"
                                        >
                                        <span>{{ getActiveSubscriptionPaidBy(client).name }}</span>
                                    </template>
                                    <span v-else class="text-muted">—</span>
                                </td>
                                <td class="d-none d-md-table-cell">
                                    <span :title="datetime(client.created_at)" data-bs-toggle="tooltip">
                                        {{ date(client.created_at) }}
                                    </span>
                                </td>
                                <td class="d-table-cell">
                                    <div class="dropdown d-flex justify-content-center">
                                        <button 
                                            class="btn btn-white btn-icon-only-md" 
                                            data-bs-toggle="dropdown" 
                                            data-bs-auto-close="true" 
                                            aria-expanded="false"
                                         aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                            <a :href="'/insights/' + client.url" class="dropdown-item">
                                                <img class="icon me-2" src="/img/icons/avid-icons/bar-chart-square-01.svg" alt=""> View Insights
                                            </a>
                                            <a :href="resultsFilterUrl(client.id)" class="dropdown-item" v-if="client.data_blends.length > 0">
                                                <img class="icon me-2" src="/img/icons/avid-icons/filter-funnel-01.svg" alt=""> Edit Results Filter
                                            </a>
                                            <hr class="my-1">
                                            <a 
                                                class="dropdown-item text-danger" 
                                                href="#" 
                                                @click.prevent="confirmDeleteClient(client)"
                                            >
                                                <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt=""> Delete Client
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-else>
                                <td colspan="100%" class="text-center py-3">No clients found. <a href="/admin/clients/new">Create a new client</a>.</td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select 
                                                    class="form-select" 
                                                    name="num_per_page" 
                                                    id="num_per_page" 
                                                    v-model="num_per_page" 
                                                    @change="reloadPagination(filtered_clients)"
                                                 aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option 
                                                        v-for="num in num_per_page_options" 
                                                        :key="num" 
                                                        :value="num"
                                                    >
                                                        {{ num }}
                                                    </option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ filtered_clients.length === 0 ? '0' : item_interval }} of {{ filtered_clients.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button 
                                                v-if="page_count > 1" 
                                                class="btn btn-secondary btn-icon-only-md me-1" 
                                                @click="moveToPrevPage(filtered_clients)" 
                                                :disabled="page_index === 0"
                                                data-bs-toggle="tooltip"
                                                title="Previous page"
                                            >
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>

                                            <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                <button 
                                                    v-for="page in page_index_array" 
                                                    :key="page" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    :class="{'current-page': page === page_index + 1}" 
                                                    @click="moveToPage(page, filtered_clients)"
                                                >
                                                    {{page}}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-else>
                                                <button 
                                                    v-for="page in page_index_array.slice(0,2)" 
                                                    :key="page" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    :class="{'current-page': page === page_index + 1}" 
                                                    @click="moveToPage(page, filtered_clients)"
                                                >
                                                    {{page}}
                                                </button>

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                ...
                                                </button>
                                                <button 
                                                    v-if="page_index >= 2 && page_index < page_index_array.length - 1" 
                                                    class="btn btn-none btn-icon-only-md current-page"
                                                >
                                                    {{page_index + 1}}
                                                </button>

                                                <button v-if="page_index < page_index_array.length - 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                ...
                                                </button>
                                                <button 
                                                    :class="{'current-page': page_index === page_index_array.length - 1}" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    @click="moveToPage(page_index_array.length, filtered_clients)" 
                                                    :key="page_index_array.length"
                                                >
                                                    {{ page_index_array.length }}
                                                </button>
                                            </div>

                                            <button 
                                                v-if="page_count > 1" 
                                                class="btn btn-secondary btn-icon-only-md ms-1" 
                                                @click="moveToNextPage(filtered_clients)" 
                                                :disabled="page_index === page_count - 1"
                                                data-bs-toggle="tooltip"
                                                title="Next page"
                                            >
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>                    
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { useNotifications } from '../../composables/useNotifications';
import tablePaginationMixin from '../../mixins/table_pagination';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AgencyClients',
    props: {
        agency: {
            type: Object,
            required: true
        },
        clients: {
            type: Array,
            required: true
        }
    },
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    mixins: [tablePaginationMixin],
    data() {
        return {
            filtered_clients: [],
            list_shown: [],
            search_key: '',
            sort_key: null,
            sort_order: 'asc',
        };
    },
    mounted() {
        if(this.clients && this.clients.length > 0) {
            this.filtered_clients = [...this.clients];
        }
        this.reloadPagination(this.filtered_clients);

        // Initialize tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (var i = 0; i < tooltipTriggerList.length; i++) {
          (function(index) {
            tooltipTriggerList[index].addEventListener('click', function() {
              tooltipList[index].hide();
            });
            tooltipTriggerList[index].addEventListener('mouseleave', function() {
              tooltipList[index].hide();
            });
          })(i);
        }
    },
    methods: {
        filterClients() {
            if (this.search_key.trim() === "") {
                this.filtered_clients = [...this.clients];
            } else {
                const key = this.search_key.toLowerCase();
                this.filtered_clients = this.clients.filter(client => {
                    const name = (client.name || '').toLowerCase();
                    const domain = (client.domain || '').toLowerCase();
                    return name.includes(key) || domain.includes(key);
                });
            }
            this.reloadPagination(this.filtered_clients);
        },
        sortByKey(key) {
            if (this.sort_key === key) {
                this.sort_order = (this.sort_order === 'asc') ? 'des' : 'asc';
            } else {
                this.sort_key = key;
                this.sort_order = 'asc';
            }
            this.sortData();
        },
        sortData() {
            if (this.sort_order === 'asc') {
                this.filtered_clients.sort((a, b) => {
                    const aVal = a[this.sort_key] || '';
                    const bVal = b[this.sort_key] || '';
                    return aVal.localeCompare(bVal);
                });
            } else {
                this.filtered_clients.sort((a, b) => {
                    const aVal = a[this.sort_key] || '';
                    const bVal = b[this.sort_key] || '';
                    return bVal.localeCompare(aVal);
                });
            }
            this.reloadPagination(this.filtered_clients);
        },
        confirmDeleteClient(client) {
            Swal.fire({
                title: `Are you sure you want to remove ${client.name}?`,
                text: "Deleting the client will remove all associated data and connections. This action cannot be undone.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, confirm",
                customClass: {
                    popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteClient(client);
                }
            });
        },
        deleteClient(client) {
            axios.delete(`/api/agencies/${this.agency.id}/clients/${client.url}`)
                .then(response => {
                    // Remove client from the local list
                    const index = this.clients.findIndex(c => c.id === client.id);
                    if (index !== -1) {
                        this.clients.splice(index, 1);
                        this.filterClients();
                    }
                    this.showNotification({
                        text: '<strong>' + client.name + '</strong> was removed!'
                    });
                })
                .catch(error => {
                    console.error('Error deleting client:', error);
                    this.showNotification({
                        text: 'Error removing this client. Please try again.',
                        type: 'error'
                    });
                });
        },
        addClientUrl() {
            return `/admin/agency/${this.agency.id}/client/add`;
        },
        editClientUrl(clientId) {
            return `/admin/agency/${this.agency.id}/client/${clientId}`;
        },
        resultsFilterUrl(clientId) {
            return `/admin/agency/${this.agency.id}/client/${clientId}/results`;
        },
        getActiveSubscriptionPaidBy(client) {
            const subs = client.subscriptions;
            if (!subs || !subs.length) return null;
            return subs[0].paid_by || null;
        },
        paidByPhotoUrl(client) {
            const paidBy = this.getActiveSubscriptionPaidBy(client);
            if (!paidBy) return null;
            // Client appends image; Agency appends photo_url
            return paidBy.image || paidBy.photo_url || null;
        },
        paidByIcon(client) {
            const type = client.subscriptions?.[0]?.paid_by_type || '';
            return type === 'App\\Models\\Agency'
                ? '/img/icons/avid-icons/building-08.svg'
                : '/img/icons/avid-icons/user.svg';
        }
    }
})
</script>